var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[(_vm.downloadCompleted)?_c('my-ski-row',[_vm._v(" Download af filen er fuldført. Du kan nu lukke browseren. ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }